import graphql from '@/graphql';
import graphqlHelper from '@/services/graphqlHelper';

const findWeekOrders = ({ startDate, endDate, office }) =>
  graphqlHelper({
    query: graphql.order.queries.findWeekOrders,
    variables: {
      startDate,
      endDate,
      office,
    },
  });

const findWeekOrdersByCountry = ({ startDate, endDate, country }) =>
  graphqlHelper({
    query: graphql.order.queries.findWeekOrdersByCountry,
    variables: {
      startDate,
      endDate,
      country,
    },
  });

const findWeekOrdersByUser = ({ startDate, endDate, office }) =>
  graphqlHelper({
    query: graphql.order.queries.findWeekOrdersByUser,
    variables: {
      startDate,
      endDate,
      office,
    },
  });

const findOrdersByUser = ({ startDate, endDate, office }) =>
  graphqlHelper({
    query: graphql.order.queries.findOrdersByUser,
    variables: {
      startDate,
      endDate,
      office,
    },
  });

const placeOrder = ({ menuEvent, meal, office }) =>
  graphqlHelper({
    query: graphql.order.mutations.placeOrder,
    variables: {
      menuEvent,
      meal,
      office,
    },
  });

const deleteOrderByMenuEvent = ({ menuEvent, meal }) =>
  graphqlHelper({
    query: graphql.order.mutations.deleteOrderByMenuEvent,
    variables: {
      menuEvent,
      meal,
    },
  });

const deleteOrdersByDay = ({ date, office, startDate, endDate }) =>
  graphqlHelper({
    query: graphql.order.mutations.deleteOrdersByDay,
    variables: {
      date,
      office,
      startDate,
      endDate,
    },
  });

const deleteWeekOrders = ({ startDate, endDate }) =>
  graphqlHelper({
    query: graphql.order.mutations.deleteWeekOrders,
    variables: {
      startDate,
      endDate,
    },
  });

const deleteWeekOrdersByEvent = ({ startDate, endDate, mealEvent, office }) =>
  graphqlHelper({
    query: graphql.order.mutations.deleteWeekOrdersByEvent,
    variables: {
      startDate,
      endDate,
      event: mealEvent,
      office,
    },
  });

const deleteOrderById = (id) =>
  graphqlHelper({
    query: graphql.order.mutations.deleteOrderById,
    variables: {
      id,
    },
  });

const checkUserOrder = ({ orderId, served }) =>
  graphqlHelper({
    query: graphql.order.mutations.checkUserOrder,
    variables: {
      orderId,
      served,
    },
  });

export {
  findWeekOrders,
  findWeekOrdersByCountry,
  findWeekOrdersByUser,
  findOrdersByUser,
  placeOrder,
  deleteOrderByMenuEvent,
  deleteOrdersByDay,
  deleteWeekOrders,
  deleteWeekOrdersByEvent,
  deleteOrderById,
  checkUserOrder,
};



// WEBPACK FOOTER //
// ./src/services/order.js